/* import __COLOCATED_TEMPLATE__ from './s3-config-bucket.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();